var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VBtn',{staticClass:"mt-8 font-bold text-white bg-gray-500 hover:bg-gray-600 focus:outline-none",attrs:{"type":"submit","block":"","large":"","depressed":"","loading":_vm.loading,"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }